import React, { Component } from 'react';
import { connect } from 'react-redux';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import Modal from '../../../components/Modal';
import Alert from '../../../components/Alert';
import { fetchClientes, clearClientes, searchProformas, fetchFichasVenta,clearProformasBuscar, fetchCompanias, fetchAreasVenta, fetchVendedores, clearVendedores, fetchColaboradores, clearColaboradores } from '../../../actions';
import validateClient from '../../../utils/validateClient';
import updateCliente from '../../../utils/updateCliente';
// import validateProforma from '../../utils/validateProforma';
import { FadeLoader } from 'react-spinners';


const VACIO = '';
class CambiarCliente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      searchOption: 'cadena',
      searchInput: '',
      lastOption: 'cadena',
      lastInput: '',
      errorMessage: '',
      hasError: false,
      clientTable: false,
      proformTable: false,
      searchByProforma: false,
      stillSearch: true,
      // filters
      areaVentaFilter: '',
      companyFilter: '',
      vendedorId: '',
      vendedorName: '',
      // values for create fdv
      clientId: '',
      clientName: '',
      selectedProform: [],
      observaciones: '',
      codFilial: '',
      muestraLoad:'none',
      SecondStep: {
        cardExpanded: [],
        condicionesProforma: '',
        capacitacionesProforma: '',
        usosProforma: '',
        coloresProforma: '',
      },
      colaborador:'',
      colaboradoresSeleccionados: [],
      checkAttach:[{'id':'0001','descripcion':'Adjuntar Resumen FV'},
                   {'id':'0002','descripcion':'Adjuntar Proforma'}]
    };
  }

  changeColaborador = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  selectColaborador = (key) => {
    const colaboradorSelected = this.state.colaboradoresSeleccionados.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;
      const apellidos = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const correo = this.props.colaboradores
          .filter(({ idUsuario }) => idUsuario.toString() === key)[0].correo;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}`, correo : correo };
      this.setState({ colaborador: '', colaboradoresSeleccionados: [...this.state.colaboradoresSeleccionados, colaborador] });
      this.props.clearColaboradores();
    }
  }

  onChangeValue = e => {
    console.log(e);
      this.setState({ [e.target.name]: e.target.value })
  }

  componentDidMount() {
    this.props.fetchCompanias();
    this.props.fetchAreasVenta();

    const { cliente, proforma } = this.props.querys;
    if (cliente && cliente.length === 8) {
      this.search('codcliente', cliente);
      this.props.fetchClientes('codcliente', cliente)
        .then(() => this.showClientProform(this.props.clientes.data[0]))
        .then(() => this.props.searchProformas(null, proforma))
        .then(() => {
          if (this.props.proformas.listConsultaProforma.length && proforma) {
            this.selectProform(this.props.proformas.listConsultaProforma[0]);
          }
        });
    }


    this.props.fetchColaboradores(VACIO);
  }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value })
  onChangeSelect = e => this.setState({ [e.target.name]: e.target.value, searchInput: '' })
  onCheck = (e) => {
    if (this.state[e.target.name] === e.target.value) {
      this.setState({ [e.target.name]: '' });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  onChangeVendedores = (e) => {
    if (e.target.value.length >= 2) {
      this.props.fetchVendedores(e.target.value);
    }
    if (e.target.value.length === 0) {
      this.props.clearVendedores();
    }
    this.setState({ vendedorName: e.target.value });
  }

  onSelectVendedores = (key) => {
    this.setState({
      vendedorName: this.props.vendedores
                  .filter(({ vendedor }) => vendedor === key)[0].descripcion,
      vendedorId: key,
    }, () => this.searchByFilter());
    this.props.clearVendedores();
  }

  setProformas = () => {
    if (this.state.selectedProform.length === 1) {
      const {
        codCliente,
        codAreaVta,
        codCia,
        codFilial,
        codVendedor,
        vendedor,
      } = this.state.selectedProform[0];
      this.setState({
        areaVentaFilter: codAreaVta,
        companyFilter: codCia,
        codFilial,
        vendedorName: vendedor,
        vendedorId: codVendedor,
        stillSearch: false,
      });
      this.props.searchProformas(codCliente, null, codAreaVta, codCia, codVendedor);
      this.setState({
        companyValue: codCia,
        proformasTable: true,
        clientName: this.state.selectedProform[0].cliente,
        clientId: this.state.selectedProform[0].codCliente,

      });
    }
  }

  backToStep1 = () => {
    this.setState({
      SecondStep: {
        cardExpanded: [],
        condicionesProforma: '',
        capacitacionesProforma: '',
        usosProforma: '',
        coloresProforma: '',
      },
      observaciones: '',
    });
    this.previousStep();
  }

  goToStep3 = (...object) => {
    this.setState({ SecondStep: object[0] });
    this.nextStep();
  }

  searchByVendedor = () => {
    if (this.state.vendedorName.length === 0) {
      this.setState({
        vendedorId: '',
      }, () => this.searchByFilter());
    }
    this.searchByFilter();
  }

  nextStep = () => this.setState({ step: this.state.step + 1 })
  previousStep = () => this.setState({ step: 1 })
  paginateClient = ({ selected }) => {
    this.props.fetchClientes(this.state.lastOption, this.state.lastInput, selected + 1);
  }

  paginateProform = ({ selected }) => {
    this.props.searchProformas(this.state.clientId, '', this.state.areaVentaFilter, this.state.companyFilter, this.state.vendedorId, selected + 1);
  }

  goToClients = () => {
    this.setState({ clientTable: true, proformTable: false, stillSearch: true, clientName: '', companyFilter: '', areaVentaFilter: '', selectedProform: [], vendedorId: '', vendedorName: '' });
  }

  showAndHideAlert = (message) => {
    this.setState({ hasError: true, errorMessage: message });
    setTimeout(() => this.setState({ hasError: false }), 5000);
  }

  showClientProform = (client) => {
    const { proforma } = this.props.querys;

    validateClient(client.codigo, 0)
      .then(({ estadoTrama, mensaje }) => {
        if (estadoTrama === '1') {
          this.props.clearProformasBuscar();
          if (!proforma) {
            this.props.searchProformas(client.codigo);
          }
          this.setState({
            clientTable: false,
            proformTable: true,
            stillSearch: false,
            clientName: client.nombre,
            clientId: client.codigo,
            step: 2,
          });
        } else if (estadoTrama === '0' || estadoTrama === '-1') {
          this.showAndHideAlert(mensaje);
        } else {
          this.showAndHideAlert(`Hubo un error con el servicio ${estadoTrama}`);
        }
      });
  }

  selectProform = (proforma) => {
    const { selectedProform } = this.state;
    if (selectedProform.filter(({ nroProforma }) => nroProforma === proforma.nroProforma).length) {
      if (selectedProform.length === 1) {
        this.props.searchProformas(this.state.clientId);
        this.setState({ companyFilter: '', areaVentaFilter: '', selectedProform: [], vendedorId: '', vendedorName: '' });
      } else {
        this.setState({
          selectedProform: selectedProform
                            .filter(({ nroProforma }) => nroProforma !== proforma.nroProforma),
        });
      }
    } else {
      // validateProforma(proforma.nroProforma)
      //   .then((response) => {
      //     if (response.estadoTrama === '1') {
      this.setState({
        selectedProform: [...this.state.selectedProform, proforma],
      }, this.setProformas);
        //   } else {
        //     console.log(response.mensaje);
        //     this.showAndHideAlert('El Cliente no tienen una reserva vigente con el color  de la proforma. No se podra crear la Ficha de Venta');
        //   }
        // });
    }
  }

  unselectProforma = (proforma) => {
    if (this.state.selectedProform.length === 1) {
      this.props.searchProformas(this.state.clientId);
      this.setState({ companyFilter: '', areaVentaFilter: '', selectedProform: [], vendedorId: '', vendedorName: '' });
    } else {
      this.setState({
        selectedProform: this.state.selectedProform.filter(it => it !== proforma.proforma),
      });
    }
  }

  removeColaborador = (id) => {
    const { colaboradoresSeleccionados } = this.state;
    this.setState({ colaboradoresSeleccionados: colaboradoresSeleccionados.filter(colaborador => id !== colaborador.id) });
  }

  search = (option, value) => {
    if (!value.trim() || (option === 'nroProforma' && value.length !== 10)) {
      return false;
    } else if (this.state.searchOption === 'nroProforma') {
      this.setState({
        lastInput: this.state.searchInput,
        lastOption: this.state.searchOption,
        searchByProforma: true,
        clientTable: false,
        proformTable: true,
        selectedProform: [],
      });
      this.props.clearProformasBuscar();
      this.props.searchProformas(null, value);
      return true;
    }
    this.setState({
      lastInput: this.state.searchInput,
      lastOption: this.state.searchOption,
      clientTable: true,
      proformTable: false,
    });
    this.props.clearClientes();
    this.props.fetchClientes(option, value);
    return true;
  }

  searchByFilter = () => {
    // document.querySelectorAll('.customToggle').forEach(dropdown => dropdown.classList.remove('open'));
      var lista=document.querySelectorAll('.customToggle');
      for (var i = 0; i < lista.length; i++) {
          lista[i].classList.remove('open')
      }
    this.props.clearProformasBuscar();
    this.props.searchProformas(this.state.clientId, '', this.state.areaVentaFilter, this.state.companyFilter, this.state.vendedorId);
    this.setState({ selectedProform: [] });
  }


  guardarCliente = ()=>{

      this.setState({muestraLoad:'block'});
    updateCliente(this.props.fichasVenta.fichaVentaResponse[0].numFichaVtaVeh,this.state.clientId,this.state.clientName,this.props.fichasVenta.fichaVentaResponse[0].nomPerso).then((result)=>{

      this.setState({muestraLoad:'none'});
      console.log(result);
      this.props.closeModal();
      this.props.fetchFichasVenta('', '1', '1', 'nfdv', this.props.fichasVenta.fichaVentaResponse[0].numFichaVtaVeh);

    }


    )
 }

  render() {
    const { clientes, proformas, companias, areasVenta, vendedores } = this.props;
    const {
      step, searchInput, searchOption, clientTable,
      hasError, proformTable, selectedProform, clientName,
      searchByProforma, stillSearch, companyFilter, areaVentaFilter,

    } = this.state;

    return (
      <div>
        <Modal isOpen idModal='nueva-fdv' modalSize='modal-dialog modal-lg' title='Actualizar Cliente' closeModal={this.props.closeModal}>
          <div className='modalBleed'>
          <ol className='progresStep'>
            <li
            key={1}
            className={`progresStep-item ${step > 1? 'prevActive' : null} ${step === 1 ? 'active' : null}`}
            >
            <div className='progresStep-item-circle'>
                <span className='progresStep-index'>1</span>
                <i className='progresStep-check ion-checkmark' />
            </div>
            <p>Buscar cliente</p>
            </li>

            <li
            key={2}
            className={`progresStep-item ${step > 2 ? 'prevActive' : null} ${step === 2? 'active' : null}`}
            >
            <div className='progresStep-item-circle'>
                <span className='progresStep-index'>2</span>
                <i className='progresStep-check ion-checkmark' />
            </div>
            <p>Actualizar cliente</p>
            </li>

          </ol>

          </div>
          <div className='steps-container fdvNew-slides'>
            {
            step === 1 &&
              <FirstStep
                clientes={clientes}
                proformas={proformas}
                companias={companias}
                areasVenta={areasVenta}
                vendedores={vendedores}
                companyFilter={companyFilter}
                areaVentaFilter={areaVentaFilter}
                searchOption={searchOption}
                searchInput={searchInput}
                clientTable={clientTable}
                proformTable={proformTable}
                searchByProforma={searchByProforma}
                selectedProform={selectedProform}
                clientName={clientName}
                vendedorName={this.state.vendedorName}
                stillSearch={stillSearch}
                nextStep={this.nextStep}
                onChangeValue={this.onChangeValue}
                onCheck={this.onCheck}
                onChangeSelect={this.onChangeSelect}
                search={this.search}
                paginateClient={this.paginateClient}
                showClientProform={this.showClientProform}
                selectProform={this.selectProform}
                paginateProform={this.paginateProform}
                goToClients={this.goToClients}
                unselectProforma={this.unselectProforma}
                searchByFilter={this.searchByFilter}
                fetchVendedores={this.props.fetchVendedores}
                clearVendedores={this.props.clearVendedores}
                onChangeVendedores={this.onChangeVendedores}
                onSelectVendedores={this.onSelectVendedores}
                searchByVendedor={this.searchByVendedor}

              />
          }
            {
            step === 2 &&
              <SecondStep
                nextStep={this.goToStep3}
                previousStep={this.backToStep1}
                proformas={selectedProform}
                codAreaVta={areaVentaFilter}
                clientTable={clientTable}
                {...this.state.SecondStep}
                observaciones={this.state.observaciones}
                onChangeValue={this.onChangeValue}
                paginateProform={this.paginateProform}
                showClientProform={this.showClientProform}
                clientName = {this.state.clientName}
                clientId = {this.state.clientId}
                querys = {this.props.querys}
                closeModal={this.props.closeModal}
                fichasVenta = {this.props.fichasVenta.fichaVentaResponse[0]}
                guardarCliente = {this.guardarCliente}
                nuevaFDV
              />
          }

          </div>
        </Modal>
        {
          hasError &&
            <Alert type='alert-warning over-modal' icon='ion-alert-circled'>
              <p>{this.state.errorMessage}</p>
            </Alert>
        }

    <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
        <div className='modal-dialog modal-sm' role='document'>
          <FadeLoader color={'#F8A14A'} loading />
        </div>
      </div>

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clientes: state.clientes,
    proformas: state.proformasBuscar,
    companias: state.companias,
    areasVenta: state.areasVenta,
    vendedores: state.vendedores,
    colaboradores : state.colaboradores,
    fichasVenta :state.fichasVenta
  };
}

export default connect(mapStateToProps,
  {
    fetchClientes,
    clearClientes,
    searchProformas,
    clearProformasBuscar,
    fetchCompanias,
    fetchAreasVenta,
    fetchVendedores,
    clearVendedores,
    fetchColaboradores,
    clearColaboradores,
    fetchFichasVenta
  })(CambiarCliente);



// WEBPACK FOOTER //
// ./src/pages/modals/CambiarCliente/index.js